import BasePng from '@/assets/png/web3/base.png';
import ChainPng from '@/assets/png/web3/chain.png';
import SolanaPng from '@/assets/png/web3/solana.png';
import SuiPng from '@/assets/png/web3/sui.png';

export type ChainId =
  | 'sui'
  | 'ethereum'
  | 'base'
  | 'arbitrum'
  | 'optimism'
  | 'avalanche'
  | 'solana';

const PngChainIcon =
  (src: string) =>
  ({ size }: { size: number }) => (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      style={{ borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
    />
  );

const ChainPngIcon = PngChainIcon(ChainPng);

const CHAIN_ICONS: Record<ChainId, (_props: { size: number }) => React.ReactElement> = {
  sui: PngChainIcon(SuiPng),
  ethereum: ChainPngIcon,
  base: PngChainIcon(BasePng),
  arbitrum: ChainPngIcon,
  optimism: ChainPngIcon,
  avalanche: ChainPngIcon,
  solana: PngChainIcon(SolanaPng),
};

export const ChainIcon = ({ chainId, size = 28 }: { chainId: ChainId; size?: number }) => {
  const Icon = CHAIN_ICONS[chainId];
  return <Icon size={size} />;
};
